module.exports = __webpack_public_path__ + "img/noscfp-data.7d6dc1b9.svg";